import styled from 'styled-components';
import footerBackgroundImage from '../assets/images/waveygreen.jpg';
import {Container} from "react-bootstrap";
import {Nav} from "react-bootstrap";

export const FooterBackground = styled.div`
    background-color: var(--forest-green);
    @media (min-width: 770px) {
        background-image: url(${footerBackgroundImage});
    }
    min-height: 60px;
    margin-top:20px;
    padding-top: 25px;
    padding-bottom: 25px;
    color: #fff;
`;

export const CustomBrand = styled.div`
    font-family: "Great Vibes",serif;
    font-size: 1.5rem;
    color: #FFF;
    text-align: center;
    text-shadow: 1px 1px 3px #000;
    & span.main-brand {
        font-size: 2.2rem;
        display: block;
    }
    & span.of-small {
        font-size: 1.5rem;
    }
`;

export const FooterMenu = styled.ul`
    list-style: none;
    padding-left: 30%;
    margin: 0;
    margin-top: 1rem;
    margin-bottom: 2rem;
    & a {
        color: #fff;
    }
`;

export const StyledFooterContainer = styled(Container)`
    
    
`;

export const CustomNavLink = styled(Nav.Link)`
    color: #fffee2;
    font-family: 'Poppins', sans-serif;
    font-weight: bold;
    font-size: 1rem;
    @media (max-width: 1200px) {
        font-size: 0.75rem;
    }

    &:hover {
        color: var(--forest-green);
    }
`;
